<template>
  <div>
    <div class="row">
      <div class="col-md-12">
        <base-crud :ref="'vehicle_licensingMonthsCrud'"
                   :crudName="$t('Vehicle Licensing Month')"
                   :newText="$t('Add')+ '  '+$t('New')"
                   :table="table"
                   :columns="columns"
                   :options="options"
                   :endPoint="endPoint"
                   :enableAdd="true"
                   :enableEdit="true"
                   :enableDelete="true"
                   :enableView="false"
                   :enableReset="false"
                   :dataForm="dataForm">
        </base-crud>

      </div>
    </div>
  </div>
</template>

<script>
import BaseCrud from "../../layouts/Base/BaseCrud";

export default {
  data: function () {
    return {
      table: "vehicle_licensing_monthsTable",
      showMessageImport: false,
      vehicle_licensing_monthsTableCrud: {},
      pages: [],
      url: "",
      columns: [
        "id",
        "plate_end",
        "licensing_month",
        "vehicle_type_id",
        "actions",
      ],
      optionsOrigin: {
        filterByColumn: true,
        debounce: 1000,
        filterable: ["plate_end", "licensing_month", "vehicle_type_id"],
        pagination: {
          chunk: 10,
          dropdown: false,
          nav: "scroll"
        },
        perPage: 10,
        perPageValues: [10, 25, 50, 100],
        headings: {
          id: this.$t('id'),
          plate_end: this.$t('Plate End'),
          licensing_month: this.$t('Licensing Month'),
          vehicle_type_id: this.$t('Vehicle Type'),
          actions: this.$t('action'),
        },
        texts: {
          filterBy: this.$t('Filter'),
          defaultOption: this.$t('Select'),
        },
        templates: {
          vehicle_type_id: function (h, row, index) {
            return row.vehicle_type ? row.vehicle_type.name : "";
          },
        },
        requestFunction: function (data) {
          let requestData = {};
          let query = this.$parent.$parent.$parent.query(data.query);
          requestData.params = data;
          requestData.params.query = "";
          requestData.params.with = ["vehicleType"];

          return axios.get(this.url + "?" + query, requestData).catch(
              function (e) {
                this.dispatch("error", e);
              }.bind(this)
          );
        },
      },
      tableData: ["id", "plate_end", "licensing_month", "vehicle_type_id"],
      endPoint: "vehicle_licensing_months",
      dataForm: {},
    };
  },
  components: {
    BaseCrud
  },
  computed: {
    options() {
      const headings = {
        id: this.$t('id'),
        plate_end: this.$t('Plate End'),
        licensing_month: this.$t('Licensing Month'),
        vehicle_type_id: this.$t('Vehicle Type'),
        actions: this.$t('action'),
      }

      const texts = {
        filterBy: this.$t('Filter'),
        defaultOption: this.$t('Select'),
      }
      return {
        ...this.optionsOrigin,
        texts,
        headings,
      }
    }

  },

  methods: {
    query: function (query) {
      let columns = {
        id: "id",
        plate_end: "plate_end",
        licensing_month: "licensing_month",
        vehicle_type_id: "vehicleType[name]" // camelCase igual do backend
      };
      let filters = "";
      $.each(query, function (index, value) {
        filters += columns[index] + "=" + value + "&";
      });
      return filters;
    },
  },
};
</script>

<style scoped>
.VuePagination {
  text-align: center;
}

.uploading-image {
  display: flex;
  border-radius: 10px;
  width: 100px;
  height: 100px;
}
</style>
